import { ReactNode, useContext, useEffect, useState } from "react";

// components
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import MultiTypeDes from "../multi-type-des/MultiTypeDes/MultiTypeDes";
import { T_R_table } from "../T_R_table/T_R_table";
import ExtraQuestions from "../ExtraQuestions/ExtraQuestions";
import classnames from "classnames";

// languages support
import { LanguageContext } from "../../context/languageContext";
import {
  componentsNamesFactoryForTitle,
  LDRTableExplanationFactory,
  multiTypeDescriptionsMarkDownFactory,
} from "../../Helper_functions/Languages/LanguageSelector";
import Markdown from "react-markdown";
import { LanguageIdContext } from "../../context/languageIdContext";

interface TabTable_int {
  p1: number;
  p2: number;
  p3: number;
  p4: number;
  local_language?: string;
  second_language?: string;
  third_language?: string;
}

function TabTable({
  p1,
  p2,
  p3,
  p4,
  local_language,
  second_language,
  third_language,
}: TabTable_int) {
  // import context
  
  const { languageId } = useContext(LanguageIdContext);
  
  const [activeTab, setActiveTab] = useState(returnNumberIndex(p1, p2, p3, p4));
  const toggle = (number: number) => {
    setActiveTab(`${number}`);
  };

  let limitedTitle = componentsNamesFactoryForTitle(languageId, "Limited");
  let shiftingTitle = componentsNamesFactoryForTitle(languageId, "Shifting");
  let shiftedTitle = componentsNamesFactoryForTitle(languageId, "Shifted");
  let widespreadTitle = componentsNamesFactoryForTitle(languageId, "Widespread");
  let recommendationsTitle = componentsNamesFactoryForTitle(
    languageId,
    "Translation Recommendations"
  );
  let extraQuestionsTitle = componentsNamesFactoryForTitle(
    languageId,
    "Extra Questions"
  );

  let limitedMD = multiTypeDescriptionsMarkDownFactory(languageId, "limited");
  let shiftingMD = multiTypeDescriptionsMarkDownFactory(languageId, "shifting");
  let shiftedMD = multiTypeDescriptionsMarkDownFactory(languageId, "shifted");
  let widespreadMD = multiTypeDescriptionsMarkDownFactory(languageId,"widespread");
  let ldrTableMD = LDRTableExplanationFactory(languageId);

  return (
    <>
      <Nav tabs>
        <NavTitleItem
          onclick={() => toggle(1)}
          activeTab={activeTab}
          activeIndex={1}
        >
          {limitedTitle}
        </NavTitleItem>
        <NavTitleItem
          onclick={() => toggle(2)}
          activeTab={activeTab}
          activeIndex={2}
        >
          {shiftingTitle}
        </NavTitleItem>
        <NavTitleItem
          onclick={() => toggle(3)}
          activeTab={activeTab}
          activeIndex={3}
        >
          {shiftedTitle}
        </NavTitleItem>
        <NavTitleItem
          onclick={() => toggle(4)}
          activeTab={activeTab}
          activeIndex={4}
        >
          {widespreadTitle}
        </NavTitleItem>
        <NavTitleItem
          onclick={() => toggle(5)}
          activeTab={activeTab}
          activeIndex={5}
        >
          {recommendationsTitle}
        </NavTitleItem>
        <NavTitleItem
          onclick={() => toggle(6)}
          activeTab={activeTab}
          activeIndex={6}
        >
          {extraQuestionsTitle}
        </NavTitleItem>
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabPane_page pane_id={"1"}>
          <MultiTypeDes markdown={limitedMD} />
        </TabPane_page>
        <TabPane_page pane_id={"2"}>
          <MultiTypeDes markdown={shiftingMD} />
        </TabPane_page>
        <TabPane_page pane_id={"3"}>
          <MultiTypeDes markdown={shiftedMD} />
        </TabPane_page>
        <TabPane_page pane_id={"4"}>
          <MultiTypeDes markdown={widespreadMD} />
        </TabPane_page>
        <TabPane_page pane_id={"5"}>
          <T_R_table
            percent_1={p1}
            percent_2={p2}
            percent_3={p3}
            percent_4={p4}
          />
          <Markdown>{ldrTableMD}</Markdown>
        </TabPane_page>
        <TabPane_page pane_id={"6"}>
          <ExtraQuestions />
        </TabPane_page>
      </TabContent>
    </>
  );
}

export default TabTable;

//internal Componets

const TabPane_page = ({
  pane_id,
  children,
}: {
  pane_id: string;
  children: ReactNode;
}) => {
  return <TabPane tabId={pane_id}>{children}</TabPane>;
};
const NavTitleItem = ({
  onclick,
  activeTab,
  activeIndex,
  children,
}: {
  onclick?: React.MouseEventHandler<HTMLAnchorElement> | undefined;
  activeTab: string;
  activeIndex: number;
  children: ReactNode;
}) => {
  return (
    <NavItem>
      <NavLink
        className={classnames({ active: activeTab === `${activeIndex}` })}
        onClick={onclick}
      >
        {children}
      </NavLink>
    </NavItem>
  );
};

//helper function
const returnNumberIndex = (
  num1: number,
  num2: number,
  num3: number,
  num4: number
) => {
  let largest_num = Math.max(num1, num2, num3, num4);

  switch (largest_num) {
    case num1:
      return "1";
    case num2:
      return "2";
    case num3:
      return "3";
    case num4:
      return "4";

    default:
      return "1";
  }
};
